<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Meu Perfil</div>
            </div>
            <div class="card-body">
              <div class="form-group">
                <img
                  v-if="previewImage"
                  :src="previewImage"
                  style="card-body"
                  class="photo"
                />
                <img
                  v-else
                  :src="users.photo"
                  style="card-body"
                  class="photo"
                />
              </div>
              <div class="profile_user form-group">
                <h3 class="user_name_max">{{ users.name }}</h3>
                <hr class="hr" />
                <p style="text-align: center">{{ users.email }}</p>
                <br />
                <br />
              </div>
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="userName">
                          <span class="required">*</span> Nome:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.name"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputEmail4">
                          <span class="required">*</span> Email:
                        </label>
                        <input
                          autocomplete="off"
                          class="form-control"
                          id="userEmail"
                          placeholder=""
                          type="text"
                          v-model="users.email"
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="userCellphone">
                          <span class="required">*</span> Celular:
                        </label>
                        <input
                          class="form-control"
                          type="text"
                          v-mask="'(##) 99999-9999'"
                          v-model="users.cellphone"
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="userPhone">Telefone:</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.telphone"
                          v-mask="'(##) 9999-9999'"
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="inputZipcode">
                          <span class="required">*</span> CEP:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.cep"
                          placeholder=""
                          v-mask="'99999-999'"
                          @keyup="buscar()"
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputNumber">
                          <span class="required">*</span> Numero:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.number"
                          placeholder=""
                          id="inputNumero"
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputCity">
                          <span class="required">*</span> Cidade:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.city"
                          placeholder=""
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label for="userAddress">
                          <span class="required">*</span> Logradouro:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.street"
                        />
                      </div>
                    </div>

                    <div class="form-row">
                      <div class="form-group col-md-2">
                        <label for="inputState">
                          <span class="required">*</span> Estado:
                        </label>
                        <input
                          type="text"
                          maxlength="2"
                          class="form-control"
                          v-model="users.state"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputNeighborhood">
                          <span class="required">*</span> Bairro:
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.neighborhood"
                          placeholder=""
                        />
                      </div>
                      <div class="form-group col-md-4">
                        <label for="inputComplement">Complemento:</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="users.complement"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-6">
                        <label for="inputCompany">
                          <span class="required">*</span> Empresa:
                        </label>
                        <select v-model="users.company_id" class="form-control">
                          <option
                            v-for="company in companies"
                            :value="company.id"
                            :key="company.id"
                          >
                            {{ company.company_name_fantasy }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-6">
                        <label for="inputDepartment">
                          <span class="required">*</span> Departamento:
                        </label>
                        <select
                          v-model="users.department_id"
                          class="form-control"
                        >
                          <option
                            v-for="department in departments"
                            :value="department.id"
                            :key="department.id"
                          >
                            {{ department.description }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <hr />

                    <div class="form-group">
                      <label for="userPic">Foto do Perfil</label>
                      <input
                        type="file"
                        class="form-control"
                        id="userPic"
                        accept="image/*"
                        name="userPic"
                        @change="uploadImage"
                        placeholder
                      />
                    </div>
                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>
                    <div class="block text-right">
                      <a class="btn btn-add" @click="save">
                        Salvar
                        <i class="fa fa-save"></i>
                      </a>
                      <router-link to="/" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="modalReservado"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalReservadoTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              style="text-align: center; font-size: 16px"
              id="modalReservadoTitle"
            >
              Bem-vindo(a) ao Sistema de Salas de Reuniões!
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div style="text-align: center; font-size: 16px">
                  Antes de iniciar sua experiência na nossa plataforma, você
                  aceita os termos para á Utilização das Salas de Reuniões?
                </div>

                <div
                  style="text-align: center; font-size: 16px; margin-top: 20px"
                >
                  <input type="checkbox" v-model="accept_terms" /> Li e concordo
                  com os termos de uso da Politica de utilização de sala de
                  reunião
                </div>
                <br />
                <div class="buttons">
                  <a @click="accept()" class="btn btn-add max">Confirmar</a>
                </div>
                <br />
                <br />
                <div class="buttons">
                  <a
                    v-on:click="logout"
                    data-dismiss="modal"
                    class="btn btn-delete max"
                    >Rejeitar</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data() {
    return {
      users: {
        name: "",
        matriculation: "",
        rg: "",
        cpf: "",
        email: "",
        cellphone: "",
        date_of_birth: "",
        cat_cnh: "",
        validity_cnh: "",
        pri_cnh: "",
        number_cnh: "",
        admission_date: "",
        password: "",
        password_confirmation: "",
        branch_id: "",
        access_nivel: "",
        photo: "",
      },
      departments: [],
      accept_terms: "",

      selected: null,
      options: ["A", "B", "C", "D", "E"],

      errors: undefined,

      previewImage: null,
    };
  },
  mounted: function () {
    const self = this;

    // Tradução do Multiselect
    $("span").attr("data-select", "Pressione enter para selecionar");
    $("span").attr("data-selected", "Selecionado");
    $("span").attr("data-deselect", "Pressione enter para remover");

    var data = new Date(),
      dia = data.getDate().toString(),
      diaF = dia.length == 1 ? "0" + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = mes.length == 1 ? "0" + mes : mes,
      anoF = data.getFullYear();
    data = anoF + "-" + mesF + "-" + diaF;

    self.now = data.toString();

    this.users = this.$store.state.user;

    this.authenticated = this.$store.getters.authenticated;

    this.getDepartments();
    this.getAcceptTerms();
    self.getCompanies();
  },
  methods: {
    logout: function () {
      let self = this;
      let api = this.$store.state.api + "logout";

      self.$http
        .post(api)
        .then((response) => {
          localStorage.removeItem("token");

          self.$router.push({ path: "/login" });
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.$message("Erro", "Erro ao realizar logout", "error");
        });
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let photo = document.getElementById("userPic");

      fd.append("name", self.users.name);
      fd.append("email", self.users.email);
      fd.append("cellphone", self.users.cellphone);
      fd.append("telphone", self.users.telphone);

      fd.append("street", self.users.street);
      fd.append("neighborhood", self.users.neighborhood);
      fd.append("complement", self.users.complement);
      fd.append("number", self.users.number);
      fd.append("city", self.users.city);
      fd.append("state", self.users.state);
      fd.append("cep", self.users.cep);

      fd.append("company_id", self.users.company_id);
      fd.append("department_id", self.users.department_id);
      fd.append("access_nivel", self.users.access_nivel);
      fd.append("password", self.users.new_password);
      fd.append("password_confirmation", self.users.password_confirmation);

      fd.append("_method", "POST");

      fd.append("photo", photo.files[0] ? photo.files[0] : "");

      if (self.users.id) {
        fd.append("id", self.users.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "users";

      let fd = self.makeFormData();

      if (self.users.id) {
        api += "/" + self.users.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Usuário atualizado com sucesso`, "success");
          this.$router.push("/");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    accept: function () {
      const self = this;
      let api = self.$store.state.api + "users/accept_term";

      let fd = self.makeFormData();

      fd.append("accept_terms", self.accept_terms);
      fd.append("user_id", self.users.id);

      if (self.users.id) {
        api += "/" + self.users.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message("Sucesso", `Usuário atualizado com sucesso`, "success");

          $(function () {
            setTimeout(function () {
              window.location.href = "/";
            }, 500);
          });
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },

    getAcceptTerms: function () {
      $("#modalReservado").modal({ show: true });
    },

    getUsers: function (id) {
      const self = this;
      const api = self.$store.state.api + "users/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getDepartments: function (id) {
      const self = this;
      const api = self.$store.state.api + "departments/";

      self.$http
        .get(api)
        .then((response) => {
          self.departments = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    makeid() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    },
  },
  components: {
    BaseCrud,
  },
};
</script>

<style scoped>
.img-bor {
  width: 150px;
}

.profile_user {
  text-align: center;
}

.max {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/AcceptTerms.vue